import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import type { Integration } from '../types';

const IntegrationsSection = () => {
  const integrations: Integration[] = [
  {
    id: "1",
    name: "OpenAI GPT-4",
    logo: "https://images.unsplash.com/photo-1679403766665-67ed6cd2df30",
    logoAlt: "OpenAI logo featuring stylized AI symbol in black and white with modern geometric design",
    description: "Advanced language model for natural conversations",
    category: "AI Platform"
  },
  {
    id: "2",
    name: "WhatsApp Business",
    logo: "https://images.unsplash.com/photo-1644035772775-8e26685ad2f0",
    logoAlt: "WhatsApp Business logo with green phone icon in speech bubble on white background",
    description: "Direct customer engagement on WhatsApp",
    category: "Messaging"
  },
  {
    id: "3",
    name: "Salesforce",
    logo: "https://images.unsplash.com/photo-1728410539013-ad662a093c68",
    logoAlt: "Salesforce cloud logo featuring blue cloud icon with modern corporate branding",
    description: "CRM integration for customer data sync",
    category: "CRM"
  },
  {
    id: "4",
    name: "Zendesk",
    logo: "https://images.unsplash.com/photo-1644035772775-8e26685ad2f0",
    logoAlt: "Zendesk logo with green and white color scheme featuring stylized support icon",
    description: "Helpdesk and ticket management",
    category: "Support"
  },
  {
    id: "5",
    name: "Shopify",
    logo: "https://images.unsplash.com/photo-1658297063569-162817482fb6",
    logoAlt: "Shopify logo with green shopping bag icon and modern e-commerce branding",
    description: "E-commerce platform integration",
    category: "E-commerce"
  },
  {
    id: "6",
    name: "Google Calendar",
    logo: "https://images.unsplash.com/photo-1553895501-af9e282e7fc1",
    logoAlt: "Google Calendar logo featuring colorful calendar icon with Google's signature color palette",
    description: "Appointment scheduling and management",
    category: "Productivity"
  },
  {
    id: "7",
    name: "Slack",
    logo: "https://images.unsplash.com/photo-1496200186974-4293800e2c20",
    logoAlt: "Slack logo with colorful hashtag symbol representing team communication platform",
    description: "Team collaboration and notifications",
    category: "Communication"
  },
  {
    id: "8",
    name: "HubSpot",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f949a104-1763713774623.png",
    logoAlt: "HubSpot logo featuring orange sprocket icon with modern marketing automation branding",
    description: "Marketing automation and CRM",
    category: "Marketing"
  }];


  const categories = Array.from(new Set(integrations.map((i) => i.category)));

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Icon name="Plug" size={16} />
            <span>Integrations</span>
          </div>
          
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Seamlessly Connect Your Tools
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our AI chatbot integrates with your existing tech stack for unified workflows
          </p>
        </div>
        
        <div className="space-y-12">
          {categories.map((category) =>
          <div key={category}>
              <h3 className="text-xl font-semibold text-text-primary mb-6 flex items-center space-x-2">
                <Icon name="Folder" size={20} className="text-primary" />
                <span>{category}</span>
              </h3>
              
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {integrations.
              filter((integration) => integration.category === category).
              map((integration) =>
              <div
                key={integration.id}
                className="bg-card rounded-xl p-6 border border-border hover:shadow-lg transition-all duration-fast hover:-translate-y-1">

                      <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-surface mb-4 mx-auto">
                        <Image
                    src={integration.logo}
                    alt={integration.logoAlt}
                    className="w-12 h-12 object-contain" />

                      </div>
                      
                      <h4 className="text-lg font-semibold text-text-primary text-center mb-2">
                        {integration.name}
                      </h4>
                      
                      <p className="text-sm text-text-secondary text-center">
                        {integration.description}
                      </p>
                    </div>
              )}
              </div>
            </div>
          )}
        </div>
        
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-surface text-text-secondary px-6 py-3 rounded-lg">
            <Icon name="Plus" size={20} />
            <span className="font-medium">Need a custom integration? We can build it for you</span>
          </div>
        </div>
      </div>
    </section>);

};

export default IntegrationsSection;